import { ITemplate } from 'entities/template/template';
import { TemplateTypes } from '../constants/templateTypes';

const globalSiteId = import.meta.env.VITE_GLOBAL_SITE_ID;

const getEmailTrackingUnsubscribeQueryKey = (template: ITemplate): string =>
  template.siteId === globalSiteId ? 'globalEmailTrackingUnsubscribes' : 'emailTrackingUnsubscribes';

export const getQueryKeysToInvalidate = (template: ITemplate): string => {
  const { type } = template;

  if (type === TemplateTypes.unsubscribeEmailTracking) {
    return getEmailTrackingUnsubscribeQueryKey(template);
  }

  switch (type) {
    case TemplateTypes.unsubscribe:
      return 'unsubscribes';
    case TemplateTypes.dataAcquisition:
      return 'emailAcquisitions';
    case TemplateTypes.sendMyBasket:
      return 'sendMyBasket';
    case TemplateTypes.displayOnly:
      return 'displayOnly';
    case TemplateTypes.mpsEmbed:
      return 'mpsEmbed';
    case TemplateTypes.mpsPopup:
      return 'mpsPopup';
    default:
      return 'templates';
  }
};

export const getOnsiteQueryKeysToInvalidate = (template: ITemplate): string => {
  const { type } = template;

  switch (type) {
    case TemplateTypes.dataAcquisition:
      return 'emailAcquisitions';
    case TemplateTypes.sendMyBasket:
      return 'sendMyBasket';
    case TemplateTypes.displayOnly:
      return 'displayOnly';
    case TemplateTypes.mpsEmbed:
      return 'mpsEmbed';
    case TemplateTypes.mpsPopup:
      return 'mpsPopup';
    default:
      return 'emailAcquisitions';
  }
};

export const getOffsiteQueryKeysToInvalidate = (template: ITemplate): string => {
  const { type } = template;

  if (type === TemplateTypes.unsubscribe) {
    return 'unsubscribes';
  }
  if (type === TemplateTypes.unsubscribeEmailTracking) {
    return getEmailTrackingUnsubscribeQueryKey(template);
  }
  return 'templates';
};
